<script>
export default {

}
</script>

<template>
  <div class="main">
      <div class="text">
        &emsp;&emsp;本實驗室專注於資料擷取技術及人工智慧的應用。資料擷取技術乃從龐大的資料中擷取出有利用價值的資訊 
        ，因大數據理論方法眾多，應用方式與時機也所有所差異，如何以智慧型資料擷取技術來提高資訊擷取的效率並應用於智慧
        物聯網系統是本實驗室所研究的主要範疇。人工智慧的應用是另一個主題，包含傳統的類神經網路、模糊理論和基因演算法
        等各類進化式演算法到深度學習理論的應用與研究測試。
      </div>
  </div>
 
</template>

<style lang="scss" scoped>
.main{
  display: flex;
  background-image: url("~@/assets/img/AIOT.jpg");
  height: 90%;
  >.text{
      margin-left: 20%;
      margin-right: 20%;
      width: 1600px;
      height: 280px;
      color: #000;
      font-size: 30px;
      margin-top: 2%;
      padding: 1%;
      border:2px grey solid;
      border-radius:5px;
      background-color:#eee;
  
  }
}


</style>